import type {LoaderFunctionArgs} from 'react-router'
import {redirect, useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../../helpers/navigationStateCache.ts'
import {withThirdPartiesParam} from '../../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps'
import NewsDetailComponentRaw from './index.js'

import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const NewsDetailComponent = withThirdPartiesParam(NewsDetailComponentRaw)

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const routeInfo = {
    location: {
      pathname: url.pathname,
      query: Object.fromEntries(url.searchParams.entries()),
      search: url.search,
      state: getNavigationState(url.pathname)
    },
    params: {
      articleId: params.articleId
    }
  }
  const data = await getInitialProps({routeInfo, context})

  // Same legacy `__HTTP__` redirect contract RR7 ignores — see the longer note in
  // Detail/route.tsx. Here getInitialProps returns it when the article doesn't resolve
  // (redirectTo NEWS_HOME_PATH_PATTERN), so without this a dead article URL rendered an
  // empty page instead of going to /noticias/.
  const redirectTo: unknown = data?.__HTTP__?.redirectTo
  if (typeof redirectTo === 'string' && redirectTo !== '') {
    return redirect(redirectTo)
  }

  return data
}

export function Component() {
  const data = useLoaderData()
  return <NewsDetailComponent {...data} />
}
